<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>store_mall_directory</mat-icon>
        <div>Site Logs</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card id='table-body'>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="serverTimestamp" matSortDirection="desc"
      matSortDisableClear="true">

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-dot">noise_control_off</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.date | date: "dd/MM/yyyy - hh:mm" }} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>

      <!-- CPF Column -->
      <ng-container matColumnDef="cpf">
        <mat-header-cell *matHeaderCellDef mat-sort-header> CPF </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.cpf }} </mat-cell>
      </ng-container>

      <!-- Phone-->
      <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Telefone </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.prefix }} {{ element.phone }} </mat-cell>
      </ng-container>

      <!-- IP Column -->
      <ng-container matColumnDef="ip">
        <mat-header-cell *matHeaderCellDef mat-sort-header> IP </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.ipAddress }} </mat-cell>
      </ng-container>

      <!-- Success Column -->
      <ng-container matColumnDef="success">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Ok </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img *ngIf='element.success' src='/assets/images/status/img_green.png'>
          <img *ngIf='!element.success' src='/assets/images/status/img_red.png'>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>